import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { useAuth } from "@/context/AuthContext";
import { EmirateSelect, Field, PageHeader, Panel } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import Billing from "@/components/Billing";
import EmailPrefs from "@/components/EmailPrefs";
import Accountants from "@/components/Accountants";

export default function Settings() {
  const { user } = useAuth();
  const { t } = useLang();
  const { setUser } = useAuth();
  const [f, setF] = useState(null);
  useEffect(() => { api.get("/company").then((r) => setF(r.data)); }, []);
  if (!f) return null;
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.put("/company", { name: f.name, company_name: f.company_name, trn: f.trn, address: f.address, phone: f.phone, emirate: f.emirate, mol_id: f.mol_id || "", wps_bank_code: f.wps_bank_code || "" });
      setUser(data);
      toast.success(t("saved"));
    } catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <div data-testid="settings-page">
      <PageHeader title={t("settings")} subtitle={t("settingsSubtitle")} />
      <Panel className="max-w-3xl p-6">
        <h3 className="mb-5 font-display text-lg font-bold">{t("companyInfo")}</h3>
        <form onSubmit={submit} className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <Field label={t("fullName")}><Input data-testid="settings-name-input" value={f.name} onChange={set("name")} /></Field>
          <Field label={t("companyName")}><Input data-testid="settings-company-input" value={f.company_name} onChange={set("company_name")} /></Field>
          <Field label={`${t("trn")} (15)`}><Input data-testid="settings-trn-input" className="font-mono" maxLength={15} value={f.trn} onChange={set("trn")} /></Field>
          <Field label={t("emirate")}><EmirateSelect data-testid="settings-emirate-select" value={f.emirate} onChange={set("emirate")} /></Field>
          <Field label={t("phone")}><Input data-testid="settings-phone-input" value={f.phone} onChange={set("phone")} /></Field>
          <Field label={t("address")}><Input data-testid="settings-address-input" value={f.address} onChange={set("address")} /></Field>
          <Field label={`${t("molId")} (13)`}><Input data-testid="settings-mol-input" className="font-mono" maxLength={13} value={f.mol_id || ""} onChange={set("mol_id")} placeholder="0000000000000" /></Field>
          <Field label={`${t("wpsBankCode")} (9)`}><Input data-testid="settings-wps-bank-input" className="font-mono" maxLength={9} value={f.wps_bank_code || ""} onChange={set("wps_bank_code")} placeholder="ADCBAEAAX" /></Field>
          <div className="sm:col-span-2"><Button data-testid="settings-save-btn" className="bg-[#007A3D] hover:bg-[#005E2E]">{t("save")}</Button></div>
        </form>
      </Panel>
      <Billing />
      <EmailPrefs />
      {!user?.readonly && <Accountants />}
    </div>
  );
}
